import styled from 'styled-components'
import { css, colors, isMobile } from 'styles'

const StyledAdvantages = styled.div`
  display: flex;
  flex-flow: column nowrap;
  font-size: 1.6rem;
  text-align: left;
  ${({ vipEnabled }) =>
    vipEnabled &&
    css`
      display: none;
    `}
  h2 {
    display: flex;
    justify-content: space-between;
    margin: 1rem 0 0;
    i {
      font-size: 3rem;
    }
  }
  .advantages-row {
    display: flex;
    border-bottom: 0.1rem solid ${colors.divider};
    padding: 1rem 0;
    &:first-of-type {
      font-weight: bold;
    }
    & span:nth-of-type(1) {
      font-size: 1.6rem;
      flex: 5;
    }
    & span:nth-of-type(n + 2) {
      align-items: center;
      display: flex;
      justify-content: center;
      flex: 1;
    }
  }
  .fine-print {
    font-size: 1.2rem;
  }
  .call-center {
    font-size: 1.6rem;
    margin-top: 0;
  }
  .fa-angle-down {
    display: ${isMobile() ? 'block' : 'none'};
  }
  ${isMobile() &&
    css`
      h2 {
        margin: 1rem 0;
      }
      ${p =>
        !p.showAdvantages &&
        css`
          .advantages-row,
          .fine-print {
            display: none;
          }
        `}
    `}
`

export default StyledAdvantages
